'use client';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Divider } from '@ravago/shared/radiance/components/divider/components/Divider/Divider';
import { ColorIcon } from '@ravago/shared/radiance/components/icon/components/ColorIcon/ColorIcon';
import { Link } from '@ravago/shared/radiance/components/link/components/Link/Link';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { DEFAULT_PRODUCER_COLOR_CODE } from '../../constants';

interface Props {
   colorName: string;
   producerColorCode?: string;
   hasMultipleSelections: boolean;
   onEdit: () => void;
}

export const SelectedColorHeader = ({ colorName, producerColorCode, hasMultipleSelections, onEdit }: Props) => {
   const translate = useTranslations();

   return (
      <Box justify="between" items="center" spacing="md" border borderRadius="largest">
         <Box direction="column" gap="3xs">
            <Box gap="sm" items="center">
               <ColorIcon colorName={colorName.toLowerCase()} />
               <Typography color="subtle">{colorName.toUpperCase()}</Typography>
               {producerColorCode && producerColorCode !== DEFAULT_PRODUCER_COLOR_CODE && (
                  <>
                     <Divider orientation="vertical" selfStretch />
                     <Typography color="subtle">{producerColorCode.toUpperCase()}</Typography>
                  </>
               )}
            </Box>
         </Box>
         {hasMultipleSelections && (
            <Link onClick={onEdit}>{translate('dynamic-product-block.edit-selection')}</Link>
         )}
      </Box>
   );
};
